// page_name##页面名称(1:商品详情页)
const page_name = 1
export default {
  /** 华丽的分割线-开始 */

  // 点击titlebar汉堡菜单栏时上报
  // sku_id##商品skuid&&
  // titlebar_content##汉堡菜单栏按钮内容id&&
  // page_name##页面名称(1:商品详情页)
  menuClick: ({ sku_id, titlebar_content, taskType }) => ({
    act: 'click',
    params: {
      cfrom: '170|002|01|077',
      event_id: '170|002|01|077',
      taskType: taskType || 2,
      sku_id,
      titlebar_content,
      page_name
    }
  })

  /** 华丽的分割线-结束 */
}
